import { type FormInstance, Form } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import type { ProdutoBodyPacoteBarra } from '@/features/produto/types/ProdutoBody';
import type { Dialog } from '@/std/dialog/types';
import { TableDefault } from '@/components/antd/TableDefault';
import { useProdutoUnidadeGetQuery } from '@/features/produto/api/apiProdutoUnidadeGet';
import { findItemAndIndex } from '@/std/array';
import { produtoTabEstoquePacoteTableColumns } from './produtoTabEstoquePacoteTableColumns';

export function ProdutoTabEstoquePacoteTable({
    form,
    dialog,
    exibirCheckboxCatalogo,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    dialog: Dialog<ProdutoBodyPacoteBarra>;
    exibirCheckboxCatalogo: boolean;
    setFormDirty: (dirty: boolean) => void;
}) {
    const produtoPacoteBarraForm = Form.useWatch('produto_pacote_barra', form) || [];
    const unidadeProdutoIdpk = Form.useWatch('pro_produto_unidade_idpk', form);
    const precoVendaProduto = Form.useWatch('pro_preco_venda', form) || 0;

    const produtoPacoteBarra = produtoPacoteBarraForm.filter((p) => p.excluir !== 'S');

    const { data } = useProdutoUnidadeGetQuery();
    const unidades = data?.registros || [];
    const unidadeProduto = unidades.find((u) => u.pru_idpk === unidadeProdutoIdpk)?.pru_sigla || '';

    const onEdit = (row: ProdutoBodyPacoteBarra): void => {
        dialog.actions.edit(row);
    };

    const onDelete = (row: ProdutoBodyPacoteBarra): void => {
        const pacotes: ProdutoBodyPacoteBarra[] = form.getFieldValue('produto_pacote_barra') || [];
        const pacote = findItemAndIndex(pacotes, (p) => p.key === row.key);
        if (!pacote) {
            return;
        }

        if (pacote.item.pcb_idpk) {
            form.setFieldValue(['produto_pacote_barra', pacote.index, 'excluir'], 'S');
        } else {
            const newPacotes = pacotes.filter((pacote) => pacote.key !== row.key);
            form.setFieldValue('produto_pacote_barra', newPacotes);
        }

        setFormDirty(true);
    };

    const columns = produtoTabEstoquePacoteTableColumns({
        exibirCheckboxCatalogo,
        onDelete,
        onEdit,
        precoVendaProduto,
        unidadeProduto,
        unidades,
    });

    return (
        <TableDefault
            columns={columns}
            dataSource={produtoPacoteBarra}
            pagination={false}
            rowKey='key'
        />
    );
}
